<template>
  <div>
    <div class="row">
      <h1 class="col-8 primary-text">{{ title }}</h1>
      <div class="col-4 text-left " @click="goToProductList(isOnline,type,title,items[0].ProductCategoryID)">
        <span class="primary-text ml-2 pointer">MORE</span>
        <i class="fa-solid fa-arrow-left fa-lg pointer"></i>
      </div>
    </div>
    <div v-if="dataLoading" class="row align-items-center ">
      <div v-for="(i) in 9" :key="i" class="col-4 col-md-3 col-lg-2 d-block p-2">
        <v-skeleton-loader
            class="mx-auto border"
            type="image"></v-skeleton-loader>
      </div>
    </div>
    <div v-else-if="items.length > 0 && items !== undefined" class="row">

      <router-link v-for="(item) in items.slice(0,9)"
                   :key="item.VendorProductID" :to="{name:'ProductDetail',query:{VendorProductID:item.VendorProductID}}"
                   class="d-md-none col-4 col-md-3 col-lg-2 d-block p-2">

        <v-img :src="$replaceHttps(item.FileUrl)" :lazy-src="$replaceHttps(item.FileUrl)" alt="تصویر..." aspect-ratio="1" class="rounded-11px bg-white"
               contain></v-img>
      </router-link>

      <router-link v-for="(item,i) in items.slice(0,6)"
                   :key="i" :to="{name:'ProductDetail',query:{VendorProductID:item.VendorProductID}}" class="col-4 col-md-3 col-lg-2 d-none d-md-block p-2">

        <v-img :src="$replaceHttps(item.FileUrl)" alt="تصویر..." aspect-ratio="1" class="rounded-11px bg-white"
               contain
               :lazy-src="$replaceHttps(item.FileUrl)"></v-img>
      </router-link>

    </div>
  </div>
</template>

<script>
export default {
  name: "GridTemplate",
  props: ['items', 'title', 'dataLoading', 'type', 'isOnline'],
  data: () => ({
    sliceItems: []
  }),
  mounted() {
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    goToProductList(isOnline, type, title, ProductCategoryID) {
      if (isOnline === 'true') {
        this.$router.push({
          path: 'ProductsList',
          query: {isOnline: isOnline, type: type, Name: title, ProductCategoryID: ProductCategoryID}
        })
      } else {
        this.$router.push({
          path: 'ProductsList',
          query: {isOnline: isOnline, type: type, Name: title}
        })
      }

    }
  }
}
</script>

<style scoped>

</style>
